import {Component, OnInit} from '@angular/core';
import {InvitationPreview} from "../../models/invitationResponse";
import {ActivatedRoute, Router} from "@angular/router";
import {InvitationService} from "../../services/invitation/invitation.service";
import {HttpErrorResponse} from "@angular/common/http";
import {OAuthService} from "angular-oauth2-oidc";
import {UiToastService} from "../../shared/ui";
import {UiAlertComponent, UiBadgeComponent, UiButtonComponent, UiCardComponent} from "../../shared/ui";

@Component({
  selector: 'app-invitation-preview',
  standalone: true,
  imports: [
    UiAlertComponent,
    UiBadgeComponent,
    UiButtonComponent,
    UiCardComponent,
  ],
  templateUrl: './invitation-preview.component.html',
  styleUrl: './invitation-preview.component.scss'
})
export class InvitationPreviewComponent implements OnInit {

  loading = false;
  error: string | null = null;
  preview: InvitationPreview | null = null;
  decision: 'accept' | 'reject' | null = null;
  private token: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private invitationService: InvitationService,
    private oauthService: OAuthService,
    private toastService: UiToastService
  ) {
  }

  ngOnInit(): void {

    this.token = this.route.snapshot.queryParamMap.get('token');

    const qDecision = this.route.snapshot.queryParamMap.get('decision');
    if (qDecision === 'accept' || qDecision === 'reject') {
      this.decision = qDecision;
    }

    if (!this.token) {
      this.error = 'Missing invitation token.';
      return;
    }

    this.loading = true;
    this.invitationService.getInvitationPreview(this.token).subscribe({
      next: (dto) => {
        this.preview = dto;
        this.loading = false;
      },
      error: (e: HttpErrorResponse) => {
        if (e.status === 404) {
          this.error = 'Invitation not found or expired.';
        } else if (e.status === 410) {
          this.error = 'Invitation has already been processed.';
        } else {
          this.error = 'Failed to load invitation preview.';
        }
        this.loading = false;
      }
    });
  }

  onAccept(): void {
    this.handleDecision('accept');
  }

  onReject(): void {
    this.handleDecision('reject');
  }

  private handleDecision(decision: 'accept' | 'reject'): void {
    if (!this.token) {
      this.toastService.error('Missing invitation token.');
      return;
    }

    const redirectUri = this.router.createUrlTree(
      ['/invitation/finalize'],
      {queryParams: {token: this.token, decision}}
    ).toString();

    if (!this.oauthService.hasValidAccessToken()) {
      this.router.navigate(['/login'], {queryParams: {redirectUri}});
      return;
    }

    this.router.navigateByUrl(redirectUri);
  }

}
